/**
 * Logo — Kariyer Online marka logosu
 *
 * Props:
 *   size              {number}  — yükseklik px (default 32); genişlik aspect'e göre otomatik
 *   className         {string}  — wrapper span'e eklenir
 *   alt               {string}  — erişilebilirlik metni (default 'Kariyer Online')
 *   showWordmark      {boolean} — false ise sadece PNG render edilir (default true)
 *   wordmarkColor     {string}  — CSS color override (örn. footer dark bg için 'white')
 *   wordmarkClassName {string}  — SADECE wordmark <span>'ine eklenir (örn. "hidden sm:inline-flex")
 */
export default function Logo({ size = 32, className = '', alt = 'Kariyer Online', showWordmark = true, wordmarkColor, wordmarkClassName = '' }) {
  return (
    <span className={`inline-flex items-center gap-2.5 ${className}`}>
      <img
        src="/logo.png"
        alt={alt}
        style={{ height: size, width: 'auto' }}
        draggable={false}
      />
      {showWordmark && (
        <span
          className={`font-duo-display text-lg tracking-tight whitespace-nowrap ${wordmarkClassName}`}
          style={{ color: wordmarkColor || 'var(--text-primary)' }}
        >
          Kariyer <span style={{ color: 'var(--brand-success)' }}>Online</span>
        </span>
      )}
    </span>
  );
}
